module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/step4-338e2653fe845b8fa868e5195999391c.svg";